/** MI DOMINO - domino tile DOM builder + pip layout. Extracted from legacy. */

export const PIP_MAP: Record<number, number[]> = {
  0: [], 1: [4], 2: [0, 8], 3: [0, 4, 8],
  4: [0, 2, 6, 8], 5: [0, 2, 4, 6, 8], 6: [0, 2, 3, 5, 6, 8]
};

export function tileEl(t: [number, number] | number[], cls?: string, vertical?: boolean): HTMLDivElement {
  const el = document.createElement('div');
  el.className = `tile ${vertical ? 'v' : 'h'} ${cls || ''}` + (t[0] === t[1] ? ' double' : '');
  el.dataset.tile = t[0] + ',' + t[1];  // lets touch-drag read the ficha off the DOM
  for (const v of t) {
    const half = document.createElement('div');
    half.className = 'half';
    for (let i = 0; i < 9; i++) {
      const cell = document.createElement('div');
      if (PIP_MAP[v].includes(i)) cell.className = 'pip';
      half.appendChild(cell);
    }
    el.appendChild(half);
  }
  return el;
}
